export type SubscriptionEventFieldInputType = 'text' | 'number' | 'boolean' | 'date'

export interface SubscriptionEventFieldDef {
  key: string
  label: string
  inputType: SubscriptionEventFieldInputType
  required?: boolean
}

const TIER_FIELD: SubscriptionEventFieldDef = {
  key: 'subscriptionTier',
  label: 'Subscription tier',
  inputType: 'text',
  required: true,
}

const PURCHASE_FIELDS: SubscriptionEventFieldDef[] = [
  TIER_FIELD,
  { key: 'gaiaProductSku', label: 'Gaia product SKU', inputType: 'text', required: true },
  { key: 'price', label: 'Price', inputType: 'number', required: true },
  { key: 'currency', label: 'Currency', inputType: 'text', required: true },
  { key: 'planName', label: 'Plan name', inputType: 'text' },
  { key: 'trialPeriod', label: 'Trial period', inputType: 'boolean' },
  { key: 'paymentProvider', label: 'Payment provider', inputType: 'text' },
]

const BEHAVIORAL_BASE: SubscriptionEventFieldDef[] = [
  TIER_FIELD,
  { key: 'planName', label: 'Plan name', inputType: 'text' },
  { key: 'gaiaProductSku', label: 'Gaia product SKU', inputType: 'text' },
]

export const SUBSCRIPTION_EVENT_FIELD_DEFS: Record<string, SubscriptionEventFieldDef[]> = {
  subscription_signup: PURCHASE_FIELDS,
  subscription_renewed: PURCHASE_FIELDS,
  plan_changed: [
    ...PURCHASE_FIELDS,
    { key: 'effectiveDate', label: 'Effective date', inputType: 'date' },
    { key: 'isUpgrade', label: 'Is upgrade', inputType: 'boolean' },
    { key: 'isDowngrade', label: 'Is downgrade', inputType: 'boolean' },
  ],
  refund_completed: PURCHASE_FIELDS,
  subscription_canceled: [
    ...BEHAVIORAL_BASE,
    { key: 'cancelReason', label: 'Cancel reason', inputType: 'text' },
    { key: 'winback', label: 'Winback', inputType: 'boolean' },
  ],
  subscription_paused: [
    ...BEHAVIORAL_BASE,
    { key: 'holdStartDate', label: 'Hold start date', inputType: 'date' },
    { key: 'holdEndDate', label: 'Hold end date', inputType: 'date' },
    { key: 'pauseDate', label: 'Pause date', inputType: 'date' },
  ],
  subscription_resumed: [
    ...BEHAVIORAL_BASE,
    { key: 'resumeDate', label: 'Resume date', inputType: 'date' },
  ],
  refund_requested: BEHAVIORAL_BASE,
  subscription_comped: [
    ...BEHAVIORAL_BASE,
    { key: 'compedDays', label: 'Comped days', inputType: 'number' },
  ],
  payment_failed: [
    ...BEHAVIORAL_BASE,
    { key: 'failureReason', label: 'Failure reason', inputType: 'text', required: true },
    { key: 'price', label: 'Price', inputType: 'number' },
    { key: 'currency', label: 'Currency', inputType: 'text' },
  ],
}

export function getSubscriptionEventFieldDefs (templateId: string): SubscriptionEventFieldDef[] {
  return SUBSCRIPTION_EVENT_FIELD_DEFS[templateId] || [TIER_FIELD]
}
